/**
 * Add domNodes around a text in a node
 * @param {HTMLElement} node  the node to modify
 * @param {string|null} separator   an optional separator to determinate which text has to be sliced (by default, all the text)
 * @param {string} before     text to add before the node's text
 * @param {string} after      text to add after the node's text
 */
export function insertNodeAround(node, separator = null, before = '<strong>', after = '</strong>') {
   let text = node.innerText
   let indexSlash = separator ? text.indexOf(separator) : text.length
   let surroundedText = text.substr(0, indexSlash).trim()
   let afterSurroundedText = text.substr(indexSlash + (separator ? separator.length : 0)).trim()
   node.innerHTML = `${before}${surroundedText}${after}${separator}${afterSurroundedText}`
}

export function isEmptyArray(arr) {
   return false === Array.isArray(arr) || 0 === arr.length
}

export function isEmptyObject(obj) {
   for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
         return false
      }
   }
   return JSON.stringify(obj) === JSON.stringify({})
}

export function isObject(obj) {
   return null !== obj && 'object' === typeof obj
}

/**
 * --------------------------------------------------------------------------
 * hasOwnDeepProperty
 * Caution, check is not undefined and not empty string
 *
 * @param {object} obj Object to check
 * @param {string} path Path to access at the property
 * @return {boolean} Property exist and is not empty string
 * --------------------------------------------------------------------------
 */
export function hasOwnDeepProperty(obj, path) {
   const value = objectDeepPropertyValue(obj, path)
   return value !== '' && value !== undefined
}

/**
 * --------------------------------------------------------------------------
 * objectDeepPropertyValue
 * Return the value of an object path
 *
 * exemple:
 * obj = {"chef":{"name":"sacco"}}
 * path = "chef.name"
 * => "sacco"
 *
 * @param {object} obj Object to check
 * @param {string} path Path to access at the property
 * @return {any} Value of property
 * --------------------------------------------------------------------------
 */
export function objectDeepPropertyValue(obj, path) {
   path = path.split('.')
   let res = obj
   for (let i = 0; i < path.length; i++) {
      res = res[path[i]]
   }
   return res
}

/**
 * Test if variable is a String not empty
 *
 * @param {string} str Variable to test
 * @returns {boolean} is or not a string
 */
export function emptyString(str) {
   return typeof str !== 'string' || 0 === str.length
}

export const Slugify = (str) => {
   str = str.replace(/^\s+|\s+$/g, '')
   // Make the string lowercase
   str = str.toLowerCase()
   // Remove accents, swap ñ for n, etc
   var from = 'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;'
   var to = 'AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------'
   for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
   }
   // Remove invalid chars
   str = str
      .replace(/[^a-z0-9 -]/g, '')
      // Collapse whitespace and replace by -
      .replace(/\s+/g, '-')
      // Collapse dashes
      .replace(/-+/g, '-')
   return str
}

/**
 * Remplace le numero de contrat des url
 * par une valeur anonymisée
 * @param {string} url brute
 * @returns {string} url sans le numero de contrat
 */
export const urlAnonymizer = (url) => {
   return url.replace(/contract=\d*/i, 'contract=###')
}

/**
 * Va lire les classes css du body pour définir
 * si on est sur mobile device
 * @returns {boolean}
 */
export const isMobile = () => {
   return document.body.classList.contains('is-mobile') ? true : false
}

/**
 * Va lire les classes css du body pour définir
 * si on est sur desktop device
 * @returns {boolean}
 */
export const isDesktop = () => {
   return document.body.classList.contains('is-mobile') ? false : true
}

/**
 * --------------------------------------------------------------------------
 * comparePriority()
 * order advise push by priority's property (high priority first)
 * --------------------------------------------------------------------------
 */
export function comparePriority(a, b) {
   let ap = parseInt(a.priority)
   let bp = parseInt(b.priority)
   if (ap > bp) {
      return -1
   } else if (ap < bp) {
      return 1
   } else {
      return 0
   }
}

/**
 * --------------------------------------------------------------------------
 * Uppercase first character in string
 * --------------------------------------------------------------------------
 */
export function capitalizeFirstLetter(string) {
   return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * --------------------------------------------------------------------------
 * Uppercase first character in string
 * --------------------------------------------------------------------------
 */
export const isForcedProd = () => {
   let isForcedProd = false
   if (document.cookie.search('isForcedProd') !== -1) {
      isForcedProd = true
   }
   return isForcedProd
}

export const tagParser = (str) => {
   if (typeof str === 'string') {
      // Remplace les [color]text[/color] par <span class="color">text</span>
      let newStr = str.replace(/\[(color|bold|price|prix)\]((?:[^[]|\[(?!\/\1\]))*)\[\/(\1)\]/gm, '<span class="$1">$2</span>')
      while (str !== newStr) {
         str = newStr
         newStr = newStr.replace(/\[(color|bold|price|prix)\]((?:[^[]|\[(?!\/\1\]))*)\[\/(\1)\]/gm, '<span class="$1">$2</span>')
      }

      // Remplace les [icon=info] par <span class="icon icon-info"></span>
      newStr = str.replace(/\[icon=(info|device-smart-phone|hands-free)\]/gm, '<span class="icon icon-$1"></span>')
      while (str !== newStr) {
         str = newStr
         newStr = newStr.replace(/\[icon=(info|device-smart-phone|hands-free)\]/gm, '<span class="icon icon-$1"></span>')
      }

      // Interprétation des retours à la ligne
      newStr = newStr.replaceAll('[retour]', '<br>')

      // Interpretation du "On"
      newStr = newStr.replaceAll('[on]', '<span class="orange-on">on</span>')

      return newStr
   }
}

export const linkParser = (str) => {
   if (typeof str === 'string') {
      // Crée des liens cliquable si on detecte une URL
      str = str.replaceAll(/(http:\/\/|https:\/\/)/gm, '')
      str = str.replaceAll(/[a-zA-Z0-9\.-]+(\.fr|\.com)([\/\?][a-zA-Z\/\?\=\&0-9]+)?/gm, '<a href="https://$&" target="_blank" tabindex="-1">$&</a>')
      return str
   }
}

export const makeSSEInterface = (composant, zone, data) => {
   return {
      id: composant,
      position: 1,
      zones: [
         {
            id: zone,
            data: data,
         },
      ],
   }
}

export const replaceFilter = (string) => {
   return string.replaceAll('__SPACE__', '&nbsp;').replaceAll('__NL__', '<br>')
}

export const replaceCleaner = (string) => {
   return string.replaceAll('__SPACE__', ' ').replaceAll('__NL__', ' ')
}

export const isTouchDevice = () => {
   return (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0))
}

export const isMin736px = () => {
   return window.matchMedia("(min-width: 736px)").matches
}